<vs-dialog [config]="{ dialogContainerClass: 'max-w-[600px]' }">
  <vs-dialog-header
    [config]="{
      mode: 'simple',
      hideCloseButton: false,

      icon: 'arrow-up-right',
      iconTheme: 'primary',

      title: 'Copy ' + (policy?.title || 'policy') + ' to ' + target,
      subtitle: 'A new draft policy will be created in ' + target + '. No existing policy in ' + target + ' will be overwritten, and the original policy in ' + source + ' will not change.'
    }"
  ></vs-dialog-header>

  <div class="flex items-center justify-center gap-4 py-4">
    <div class="flex flex-col items-center gap-1">
      <span class="text-xs text-gray-500">From</span>
      <span class="rounded-md border px-3 py-1 font-semibold text-gray-900">{{ source }}</span>
    </div>
    <vs-icon name="arrow-right" size="20" class="mt-4 text-gray-500"></vs-icon>
    <div class="flex flex-col items-center gap-1">
      <span class="text-xs text-gray-500">To</span>
      <span class="rounded-md border border-primary-500 px-3 py-1 font-semibold text-primary-700">{{ target }}</span>
    </div>
  </div>

  <p class="text-sm text-gray-600">
    Coverages, plans, pricing and rating matrix, tags, documents, cancellation rules and email templates with their
    attachments are copied. Rating cells for distributors that don't exist in {{ target }} are skipped.
  </p>

  <!-- Buttons -->
  <div class="footer mt-4">
    <div class="buttons flex space-x-4">
      <button class="flex-grow" vs-button size="md" appearance="outline" [disabled]="saving" (click)="close()">
        Cancel
      </button>
      <button class="flex-grow" vs-button size="md" theme="primary" [disabled]="saving" (click)="copy()">
        Copy to {{ target }}
      </button>
    </div>
  </div>
</vs-dialog>
